'use client';

import { useEffect } from 'react';

import { useUserAbilities } from '~/shared/hooks/useUserAbilities';

export function DatadogAbilitiesTracker() {
  const { data: abilitiesData } = useUserAbilities();

  useEffect(() => {
    if (!abilitiesData) return;

    async function trackAbilities() {
      const { datadogRum } = await import('@datadog/browser-rum');
      datadogRum.setUserProperty(
        'managedZones',
        JSON.stringify(abilitiesData!.zones)
      );
      datadogRum.setUserProperty(
        'roles',
        JSON.stringify(abilitiesData!.role)
      );
    }

    trackAbilities();
  }, [abilitiesData]);

  return null;
}
